module.exports = __webpack_public_path__ + "static/media/rockWallSheetLeft.7e006e2a.png";